import classNames from 'classnames';
import React from 'react';
import styles from './index.module.scss';
interface Props {
  className?: string;
  children?: any;
  style?: React.CSSProperties;
  hasValue?: boolean;
}
const EmptyPlaceholder: React.FC<Props> = ({
  children,
  style,
  hasValue,
  className
}) => {
  if (children && hasValue) return React.Children.map(children, c => c);
  return (
    <div className={classNames(styles.container, className)} style={style}>
      空空如也，啥也没有
    </div>
  );
};

export default EmptyPlaceholder;
